import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";
import DialogBox from "../../component/DialogBox";
import { LuFilter } from "react-icons/lu";
import InputField from "../../component/InputField";
import { DatePicker } from "@mui/x-date-pickers";
import SelectField from "../../component/SelectField";
import PaginationBar from "../../component/PaginationBar";

function AllHiringReq() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.hiringReq === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [hiringReqData, setHiringReqData] = useState([]);
  const [reload, setReload] = useState(false);
  const [openFrom, setOpenFrom] = useState(undefined);
  const [openTo, setOpenTo] = useState(undefined);
  const [closedFrom, setClosedFrom] = useState(undefined);
  const [closedTo, setClosedTo] = useState(undefined);
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("Open");

  // fetch hiring requests
  async function getHiringReq() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hiring/request/get/single/manager/request/${page}`,
        method: "get",
        withCredentials: true,
        params: {
          search: search,
          startOpenDate: openFrom,
          endOpenDate: openTo,
          startCloseDate: closedFrom,
          endCloseDate: closedTo,
          status: selectedStatus,
        },
      });
      console.log(res.data?.data);
      setHiringReqData(res.data?.data?.data || []);
      setTotalPage(res.data?.data?.totalPages);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Hiring request fetch failed");
    } finally {
      setLoading(false);
    }
  }

  const handleRefresh = () => setReload((prev) => !prev);

  const statusArr = [
    {
      title: "Open",
      value: "Open",
    },
    {
      title: "In Progress",
      value: "In Progress",
    },
    {
      title: "Hold",
      value: "Hold",
    },
    {
      title: "Completed",
      value: "Completed",
    },
    {
      title: "Rejected",
      value: "Rejected",
    },
  ];

  useEffect(() => {
    getHiringReq();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            All Hiring Requests
          </h1>
          <div className="mt-5">
            <div className="flex justify-end items-end w-full mb-3">
              <DialogBox
                trigger={
                  <ButtonCompo startIcon={<LuFilter />}>Filter</ButtonCompo>
                }
                title="Filter"
                actionButton={
                  <ButtonCompo onClick={handleRefresh}>Apply</ButtonCompo>
                }
              >
                <div>
                  <section className="space-y-3">
                    <InputField
                      label="Search"
                      helperText="Search with role, skills, YoE and position"
                      onChange={(eve) => setSearch(eve?.target?.value)}
                    />
                  </section>
                  <div className="mt-3">
                    <div className="">
                      <p className="text-slate-700 text-[14px]">Opened On</p>
                      <section className="flex justify-center items-center gap-3 mt-1">
                        <DatePicker
                          label="From"
                          onChange={(eve) => setOpenFrom(eve)}
                        />
                        <DatePicker
                          label="To"
                          onChange={(eve) => setOpenTo(eve)}
                        />
                      </section>
                    </div>
                    <div className="mt-3">
                      <p className="text-slate-700 text-[14px]">Closed On</p>
                      <section className="flex justify-center items-center gap-3 mt-1">
                        <DatePicker
                          label="From"
                          onChange={(eve) => setClosedFrom(eve)}
                        />
                        <DatePicker
                          label="To"
                          onChange={(eve) => setClosedTo(eve)}
                        />
                      </section>
                    </div>
                    <div className="mt-5">
                      <SelectField
                        label={"Status"}
                        value={selectedStatus}
                        valueArray={statusArr}
                        setValue={(eve) =>
                          setSelectedStatus(eve?.target?.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </DialogBox>
            </div>
            {hiringReqData?.length === 0 ? (
              <div className="text-center mt-5 text-[20px] text-slate-500 font-semibold">
                No request found
              </div>
            ) : (
              <div>
                <Table>
                  <TableHead>
                    <TableRow className="!bg-blue-500">
                      <TableCell className="!text-center !text-white">
                        SL No.
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Status
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Manager
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Requested On
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Role
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Position
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Years of Experience
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Joining Duration
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="border">
                    {hiringReqData.map((req, i) => (
                      <TableRow>
                        <TableCell className="!text-center">{i + 1}</TableCell>
                        <TableCell className="!text-center">
                          {req?.status === "Open" ? (
                            <section className="bg-blue-100 py-1 px-2 rounded-full text-blue-600 font-medium text-center">
                              Open
                            </section>
                          ) : req?.status === "In Progress" ? (
                            <section className="bg-slate-100 py-1 px-2 rounded-full text-slate-600 font-medium text-center">
                              In Progress
                            </section>
                          ) : req?.status === "Hold" ? (
                            <section className="bg-yellow-100 py-1 px-2 rounded-full text-yellow-600 font-medium text-center">
                              Hold
                            </section>
                          ) : req?.status === "Completed" ? (
                            <section className="bg-green-100 py-1 px-2 rounded-full text-green-600 font-medium text-center">
                              Completed
                            </section>
                          ) : (
                            <section className="bg-red-100 py-1 px-2 rounded-full text-red-600 font-medium text-center">
                              Rejected
                            </section>
                          )}
                        </TableCell>
                        <TableCell className="!text-center">
                          {req?.userManagerName ||
                            req?.companySuperadminManagerName}
                        </TableCell>
                        <TableCell className="!text-center">
                          {new Date(req?.openedOn).toLocaleDateString("en-In")}
                        </TableCell>
                        <TableCell className="!text-center">
                          {req?.role}
                        </TableCell>
                        <TableCell className="!text-center">
                          {req?.position}
                        </TableCell>
                        <TableCell className="!text-center">
                          {req?.yearsOfExperience}
                        </TableCell>
                        <TableCell className="!text-center">
                          {req?.expectedJoiningDuration}
                        </TableCell>
                        <TableCell className="!text-center">
                          <Link to={`/admin/hiring/req/single/request/${req?._id}`}>
                            <ButtonCompo>View</ButtonCompo>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <PaginationBar
                  attendancePage={page}
                  setAttendancePage={setPage}
                  totalAttendancePage={totalPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AllHiringReq;
